import React, { Component } from "react";
import Typical from "react-typical";
import Switch from "react-switch";

class Header extends Component {
  titles = [];

  constructor() {
    super();
    this.state = { checked: false };
    this.onThemeSwitchChange = this.onThemeSwitchChange.bind(this);
  }

  onThemeSwitchChange(checked) {
    this.setState({ checked });
    this.setTheme();
  }

  setTheme() {
    var dataThemeAttribute = "data-theme";
    var body = document.body;
    var newTheme =
      body.getAttribute(dataThemeAttribute) === "dark" ? "light" : "dark";
    body.setAttribute(dataThemeAttribute, newTheme);
  }

  render() {
    if (this.props.sharedData) {
      var name = this.props.sharedData.name;
      var titles = this.props.sharedData.titles;
      var networks = this.props.sharedData.social.map(function (network) {
        return (
          <span key={network.name} className="m-4">
            <a href={network.url} target="_blank" rel="noopener noreferrer">
              <i className={network.class}></i>
            </a>
          </span>
        );
      });
      //this.titles = this.props.sharedData.titles.map(x => [ x.toUpperCase(), 1500 ] ).flat();
    }

    const HeaderTitleTypeAnimation = React.memo( () => {
      return <Typical className="title-styles" steps={this.titles} loop={50} />
    }, (props, prevProp) => true);

    return (
      <header id="home" style={{
        height: Math.max(160, window.innerHeight * 0.25),
        display: 'block',
        paddingTop: 12,
        paddingBottom: 0,
        minHeight: 0,
      }}>
        <div className="row aligner" style={{height: '100%', minHeight: 0}}>
          <div className="col-md-12">
            <div>
              <h1 className="mb-0" style={{ marginBottom: "0.3em" }}>
                <p className="styles_typicalWrapper__1_Uvh">{name}</p>
              </h1>
              <div className="title-container" style={{ marginBottom: "0.2em" }}>
                <p className="title-styles">{titles}</p>
              </div>
              {/* 
              <div style={{ marginTop: 0, marginBottom: 0 }}>
                <Switch
                  checked={this.state.checked}
                  onChange={this.onThemeSwitchChange}
                  offColor="#4f90ae"
                  onColor="#353535"
                  className="react-switch mx-auto"
                  width={70}
                  height={28}
                  uncheckedIcon={
                    <span
                      className="iconify"
                      data-icon="twemoji:owl"
                      data-inline="false"
                      style={{
                        display: "block",
                        height: "100%",
                        fontSize: 18,
                        textAlign: "end",
                        marginLeft: "10px",
                        color: "#353239",
                      }}
                    ></span>
                  }
                  checkedIcon={
                    <span
                      className="iconify"
                      data-icon="noto-v1:sun-with-face"
                      data-inline="false"
                      style={{
                        display: "block",
                        height: "100%",
                        fontSize: 18,
                        textAlign: "end",
                        marginLeft: "6px",
                        color: "#353239",
                      }}
                    ></span>
                  }
                  id="icon-switch"
                />
              </div>
              */}
            </div>
            <div className="social-links-top">{networks}</div>
          </div>
        </div>
      </header>
    );
  }
}

export default Header;
